function searchCards(data, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/cards/search`;
  return apiClient.post(route, data);
}

export default {
  searchCards
};
